// Persistencia 100% en el navegador (localStorage). Sin backend.
const STORAGE_KEY = "endless_albaranes_v1";

const uuid = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : "id-" + Date.now() + "-" + Math.random().toString(16).slice(2);

export function loadAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function saveAll(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

// Número con formato ALB-YYYYMMDD-XXX (secuencial por día).
export function nextNumero(all = loadAll()) {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  const prefix = `ALB-${y}${m}${d}-`;
  let max = 0;
  for (const a of all) {
    if (a.numero && a.numero.startsWith(prefix)) {
      const n = parseInt(a.numero.slice(prefix.length), 10);
      if (!isNaN(n) && n > max) max = n;
    }
  }
  return `${prefix}${String(max + 1).padStart(3, "0")}`;
}

export function getAlbaran(id) {
  return loadAll().find((a) => a.id === id) || null;
}

export function createAlbaran(data) {
  const all = loadAll();
  const now = new Date().toISOString();
  const albaran = {
    ...data,
    id: uuid(),
    numero: nextNumero(all),
    createdAt: now,
    updatedAt: now,
  };
  all.push(albaran);
  saveAll(all);
  return albaran;
}

export function updateAlbaran(id, data) {
  const all = loadAll();
  const idx = all.findIndex((a) => a.id === id);
  if (idx === -1) return null;
  all[idx] = {
    ...all[idx],
    ...data,
    id,
    numero: all[idx].numero,
    createdAt: all[idx].createdAt,
    updatedAt: new Date().toISOString(),
  };
  saveAll(all);
  return all[idx];
}

export function deleteAlbaran(id) {
  saveAll(loadAll().filter((a) => a.id !== id));
}

// Modelo vacío de un albarán.
export const emptyAlbaran = () => ({
  estado: "pendiente",
  remitente: { nombre: "", apellidos: "", dni: "", movil: "", direccion: "" },
  destinatario: { nombre: "", apellidos: "", dni: "", movil: "", direccion: "" },
  observaciones: "",
  firmaRecogida: "",
  firmaEntrega: "",
});
